import Image from '@anm/components/image/Image';
import { FC } from 'react';

import { AvatarWrapper } from './Wrapper';

export { AvatarWrapper };

export type AvatarProps = {
  src: string;
  alt?: string;
  size?: number;
  href?: string;
  className?: string;
};

const Avatar: FC<AvatarProps> = ({ src, alt, href, size = 50, className }) => (
  <AvatarWrapper avatarSize={size} className={className}>
    {href ? (
      <a {...{ href }}>
        <Image {...{ src, alt }} data-image={'userAvatar'} />
      </a>
    ) : (
      <Image {...{ src, alt }} data-image={'userAvatar'} />
    )}
  </AvatarWrapper>
);

export default Avatar;
